import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import { Table } from 'components/composite';
import { Field, Spacer } from '@cleartrip/bento';
import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';
import Clevertap from 'analytics'
import { FilterContext } from 'context/travelsafe';

function Airports({ airports }) {
	const [airportList, setAirportList] = useState([]);
	const [filter] = useContext(FilterContext);
	const [value, setValue] = useState('');
	const [arrayLimit, setArrayLimit] = useState(5);
	const [showMore, setShowMore] = useState(true);

	useEffect(() => {
		setAirportList(airports);
	}, [airports]);

	function filterResults(e) {
		Clevertap.event('Air_UI_action', {
			action_name: 'airport_search',
			value:e.target.value
		})
		setValue(e.target.value);
	}

	function showAll() {
		Clevertap.event('Air_UI_action', {
			action_name: 'view_quarantine_states',
		})
		setShowMore(!showMore);
		setArrayLimit(airports.length);
		// setAirports(airports);
	}

	useEffect(() => {
		if (value.length === 0) {
			setShowMore(true);
			setArrayLimit(5);
		} else {
			setShowMore(false);
			setArrayLimit(airports.length);
		}
		let filteredArr = airports.filter(
			(item) => item.name.toLowerCase().includes(value.toLowerCase()) || item.airportCode.toLowerCase().includes(value.toLowerCase())
		);
		setAirportList(filteredArr);

		if (airports.length < 5) {
			setShowMore(false);
		}
	}, [value, airports]);

	return (
		<>
			<Table>
				<Table.Head className='bg-neutral-0 br-4 c-neutral-700 fs-2 mb-2 flex flex-middle d-none--xs'>
					<Table.Column span={6} className='py-2 pl-3 '>
						{filter.isFilterApplied ? (
							<span>Airport</span>
						) : (
							<Field wrapperClassName='w-100p' onChange={(e) => filterResults(e)} value={value} placeholder='Search airport' />
						)}
					</Table.Column>
					<Table.Column span={4} className='py-2 pl-3 '>
						Status
					</Table.Column>
					<Table.Column span={6} className='py-2 pl-3 '>
						Transport
					</Table.Column>
					<Table.Column span={8} className='py-2 pl-3 '>
						Flights taking off this week*
					</Table.Column>
				</Table.Head>
			</Table>
			<Table>
				{airportList &&
					airportList.slice(0, arrayLimit).map((airport, index) => {
						return (
							<Table.Row
								className={classNames('c-neutral-700 fs-3 py-2 px-2', {
									'c-default': !airport.flightInfo,
									'c-pointer hover:elevation-3': airport.flightInfo,
								})}
								key={index}
								tablelist={airport.flightInfo}
								active={filter.isFilterApplied || airportList.length < 4}
							>
								<Table.Column span={6} xs={24} className='py-1 pl-2 flex flex-between pb-1--xs fw-700'>
									<span>
										{airport.name} ({airport.airportCode})
									</span>
									{airport.flightInfo && (
										<span className='p-relative d-none d-block--xs'>
											<div className='flex'>
												<span className='chevron-text pr-1'>Details</span>
												<Chevron height={16} width={12} className='chevron c-secondary-500' />
											</div>
										</span>
									)}
								</Table.Column>
								<Table.Column
									span={4}
									xs={24}
									className={classNames('py-1 pl-3 px-2--xs', { 'c-success-500 fw-500': airport.status.toLowerCase() === 'open' })}
								>
									{airport.status}
								</Table.Column>
								<Table.Column span={6} xs={24} className='py-1 pl-3 px-2--xs  pt-1--xs pb-1--xs'>
									{airport.transport}
								</Table.Column>
								<Table.Column span={6} xs={24} className='py-1 pl-3 d-none--xs'>
									{airport.flightsTakingOff}
								</Table.Column>
								<Table.Column span={8} xs={24} className='py-1 pl-3 d-none d-block--xs px-2--xs'>
									{airport.flightsTakingOff} Flights taking off this week*
								</Table.Column>
								{airport.flightInfo && (
									<Table.Column span={2} className='d-none--xs flex-end pr-7'>
										<Chevron height={16} width={12} className='chevron c-secondary-500' />
									</Table.Column>
								)}
							</Table.Row>
						);
					})}
			</Table>
			<Spacer className='pt-2' />
			{showMore ? (
				<span class='c-pointer c-secondary-500 fw-500 fs-3 td-none hover:td-underline' onClick={showAll}>
					View all {airports.length - arrayLimit} airports
				</span>
			) : null}
		</>
	);
}

export default Airports;
